module.exports = __webpack_public_path__ + "static/media/brush_5.e90f7391.png";